import PropTypes from 'prop-types';
import {
  FILTER_TYPE_CHECKBOX,
  FILTER_TYPE_DATE,
  FILTER_TYPE_DATE_RANGE,
  FILTER_TYPE_SELECT,
  FILTER_TYPE_TEXT,
} from '../../../constants/filterTypes';
import TextFilter from './Types/TextFilter';
import SelectFilter from './Types/SelectFilter';
import CheckboxFilter from './Types/CheckboxFilter';
import DateFilter from './Types/DateFilter';
import { Fragment } from 'react';

const FilterFactory = ({ config, onChange, value }) => {
  const filterConfig = { config, onChange, value };

  switch (config.type) {
    case FILTER_TYPE_TEXT:
      return <TextFilter {...filterConfig} />;
    case FILTER_TYPE_SELECT:
      return <SelectFilter {...filterConfig} />;
    case FILTER_TYPE_CHECKBOX:
      return <CheckboxFilter {...filterConfig} />;
    case FILTER_TYPE_DATE:
      return <DateFilter {...filterConfig} />;
    case FILTER_TYPE_DATE_RANGE:
      return (
        <div className='filter-group'>
          {config.label && <label htmlFor={config.field}>{config.label}</label>}
          {config.collection.map((filterConfig, id) => (
            <FilterFactory key={id} config={filterConfig} onChange={onChange} value={value} />
          ))}
        </div>
      );
    default:
      return <Fragment />;
  }
};

FilterFactory.propTypes = {
  /* eslint-disable-next-line react/forbid-prop-types */
  config: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  /* eslint-disable-next-line react/forbid-prop-types */
  value: PropTypes.any,
};

export default FilterFactory;
